/* globals yaCounter22765936 yaCounter52537759 */
import helpers from './../helpers';
import scroll from './scroll';
import analytics from "./analytics";
// import sidebarMobile from './mobile-menu'

const $elements = $('.js-section');

let observer;
const korsiniPicture = document.querySelector('.korsini-block__pic');

let firstEnter = false;

const callback = (entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// смена ссылки (роутинг)
			let str = entry.target.id.length === 0 ? '' : entry.target.id;

			if (!helpers.isClick) {
				const canvas = document.querySelector("canvas.webgl");
				if (str === 'main') {
					str = 'main';
					history.pushState({}, '', `/feminizm-v-rossii/${location.search}${location.hash}`);

					document.title = window.data.menu[str]?.name;
					document.querySelector('meta[name="description"]').setAttribute('content', window.data.menu[str]?.description);

					ym(22765936,'reachGoal','retro_fem_event_1')
				} else {
					history.pushState({}, '', `/feminizm-v-rossii/${str}${location.search}${location.hash}`);
					document.title = window.data.menu[str]?.name;
					document.querySelector('meta[name="description"]').setAttribute('content', window.data.menu[str]?.description);
				}

				if (str === 'revolyutsionnoe-dvizhenie') {
					helpers.$document.trigger('particle-color-white');
					ym(22765936,'reachGoal','retro_fem_event_3')
				} else {
					helpers.$document.trigger('particle-color-black');
				}

				if (str === 'revolyutsionnoe-dvizhenie' || str === 'professionalnoe-stanovlenie' || str === 'politicheskoe-voleizyavlenie') {
					canvas.classList.add('is-prof')
				} else {
					canvas.classList.remove('is-prof')
				}

				scroll.activeLink(str);

				if (str === 'professionalnoe-stanovlenie') {
					korsiniPicture.classList.remove('is-hidden');
					ym(22765936,'reachGoal','retro_fem_event_2')

				} else {
					korsiniPicture.classList.add('is-hidden');
				}

				const orangePoints2 = document.querySelector('.orange-points');
				const orangePoints4 = document.querySelector('.orange-points-4');
				const orangePoints5 = document.querySelector('.orange-points-5');

				if (str === 'politicheskoe-voleizyavlenie') {
					ym(22765936,'reachGoal','retro_fem_event_4')
					orangePoints2.classList.add('is-hidden');
					orangePoints4.classList.remove('is-hidden');
					orangePoints5.classList.remove('is-hidden');
				} else {
					canvas.classList.remove('is-last');
					orangePoints2.classList.remove('is-hidden');
					orangePoints4.classList.add('is-hidden');
					orangePoints5.classList.add('is-hidden');
				}

				if(firstEnter) {
					const ymOptions = {
						referer: location.href,
						title: document.title,
					};

					analytics.init(undefined, ymOptions);
				}

				firstEnter = true;
			}
		}
	});
};

const init = () => {
	console.log('init router');

	observer = new IntersectionObserver(callback, {
		root: null,
		threshold: 0,
		rootMargin: '-50%',
	});

	$elements.each((i, el) => {
		observer.observe(el);
	});
};

const destroy = () => {
	observer.disconnect();
	observer = {};
};

let resizeTimeOut = null;

const resize = () => {
	clearTimeout(resizeTimeOut);

	resizeTimeOut = setTimeout(() => {
		destroy();
		init();
	}, 500);
};

export default {
	init,
	resize,
};
